import { useState } from 'react';
import { C, DEGRADE_ACTION } from '../../theme';
import { styleChamp } from './champs';

/**
 * Une carte de Reglages qu'on peut renommer sur place : le nom, une explication, un
 * bouton « Changer », puis un champ et deux boutons.
 *
 * Le motif existait deja deux fois dans Reglages (la ville, le fuseau) ; il vit ici pour
 * les deux noms du lot F — le mien et celui du foyer. Les deux anciens restent en place :
 * a migrer le jour ou l'un d'eux doit changer.
 */
export function LigneRenommable({
  titre,
  detail,
  valeur,
  libelleChamp,
  ariaBouton,
  modifiable,
  onEnregistrer,
}: {
  titre: string;
  detail: string;
  /** Ce que le champ contient a l'ouverture. */
  valeur: string;
  /** L'etiquette du champ — c'est aussi son `aria-label`. */
  libelleChamp: string;
  ariaBouton: string;
  modifiable: boolean;
  /** Rend le message a afficher, ou leve pour signaler l'echec. */
  onEnregistrer: (nouveau: string) => Promise<void>;
}) {
  const [edition, setEdition] = useState(false);
  const [saisie, setSaisie] = useState(valeur);
  const [envoi, setEnvoi] = useState(false);

  const enregistrer = async () => {
    const nouveau = saisie.trim();
    if (envoi || nouveau === '') return;
    if (nouveau === valeur) {
      setEdition(false);
      return;
    }
    setEnvoi(true);
    try {
      await onEnregistrer(nouveau);
      setEdition(false);
    } finally {
      setEnvoi(false);
    }
  };

  if (!edition) {
    return (
      <div
        style={{
          background: C.carte,
          border: `1px solid ${C.bordure}`,
          borderRadius: 14,
          padding: '13px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: 12,
        }}
      >
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: C.encre }}>{titre}</div>
          <div style={{ fontSize: 12, color: C.secondaire }}>{detail}</div>
        </div>
        {modifiable ? (
          <button
            type="button"
            className="pressable"
            aria-label={ariaBouton}
            onClick={() => {
              setSaisie(valeur);
              setEdition(true);
            }}
            style={{
              border: `1px solid ${C.violetBordure}`,
              background: C.carte,
              color: C.violetTexte,
              borderRadius: 10,
              padding: '7px 12px',
              fontSize: 13,
              fontWeight: 800,
              fontFamily: 'inherit',
              cursor: 'pointer',
              flexShrink: 0,
            }}
          >
            Changer
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        void enregistrer();
      }}
      style={{
        background: C.carte,
        border: `1px solid ${C.violetBordure}`,
        borderRadius: 14,
        padding: '13px 16px',
        display: 'flex',
        gap: 8,
      }}
    >
      <input
        value={saisie}
        onChange={(e) => setSaisie(e.target.value)}
        aria-label={libelleChamp}
        autoFocus
        style={{ ...styleChamp, flex: 1, minWidth: 0 }}
      />
      <button
        type="submit"
        className="pressable"
        disabled={envoi || saisie.trim() === ''}
        style={{
          height: 42,
          padding: '0 14px',
          border: 'none',
          borderRadius: 11,
          background: envoi || saisie.trim() === '' ? C.inactif : DEGRADE_ACTION,
          color: '#FFFFFF',
          fontSize: 14,
          fontWeight: 800,
          fontFamily: 'inherit',
          cursor: envoi || saisie.trim() === '' ? 'default' : 'pointer',
          flexShrink: 0,
        }}
      >
        {envoi ? '…' : 'OK'}
      </button>
      <button
        type="button"
        className="pressable"
        onClick={() => setEdition(false)}
        style={{
          height: 42,
          padding: '0 12px',
          border: `1px solid ${C.bordure}`,
          borderRadius: 11,
          background: C.carte,
          color: C.secondaire,
          fontSize: 14,
          fontWeight: 700,
          fontFamily: 'inherit',
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        Annuler
      </button>
    </form>
  );
}
